import { render } from "./MMTradeData.vue?vue&type=template&id=16c23bf6"
import script from "./MMTradeData.vue?vue&type=script&lang=js"
export * from "./MMTradeData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__